var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Flash")]),_c('div',{staticClass:"imageList"},_vm._l((this.images),function(image){return _c('div',{key:image},[_c('img',{staticClass:"flashImage",attrs:{"src":image}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }